import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

interface AiSuggestedTagProps {
  className?: string
}

// "✦ AI suggested" text. Inline by default (e.g. after a checkbox label),
// LabelWithAISuggestion restyles it to sit at the right edge of a Form.Item label.
export const AiSuggestedTag = ({ className }: AiSuggestedTagProps) => {
  const [t] = useTranslation('web_ui')

  return (
    <Tag className={className}>
      ✦ {t('work_post_sheet_form.ai_suggested.label')}
    </Tag>
  )
}

const Tag = styled('span')`
  padding-left: 8px;
  font-size: 11px;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  color: ${props => props.theme.colorLink};
`
